import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';

// Common DOM/styling for the Actions button we use at the top right of several pages
export const ActionsMenuButton = SuperCritical(({ onClick, hidden, className } : {
    onClick? : () => void;
    hidden? : boolean;
    className? : string;
}) =>
    <button className={cx('actionsmenubtncomponent pc-actions-menu-btn actions-menu-btn pc-button', className)} onClick={onClick} hidden={hidden}>
        <span className="stack-icon fa fa-bars"></span>
        <span className="actions-text">Actions</span>
    </button>
);


// WEBPACK FOOTER //
// ./apps/portcall/actionsmenubutton/view.tsx